import styled from '../../../config/theme';

const FormElement = styled.div`
  padding: 10px 0;
`;

export default FormElement;
